import { fetcher } from '@bino/utils/fetcher';
import type { User } from './types';

export function getIdentifyUserAndSendEmail(email: string) {
    return fetcher.get(`/api/authCatalog/GetUserAndSendEmail?email=${encodeURIComponent(email)}`);
}

export function createUser(user: User) {
    return fetcher.post(`/api/authCatalog/CreateUser`, user);
}
